import {AUTH_TYPE} from '@/env';

/**
 * 是否默认的用户名密码登录。
 *
 * @return {boolean} 是否
 */
// todo
export const isDefaultAuth = 'default' === AUTH_TYPE;
// export const isDefaultAuth = false;

/**
 * 使用微软 Azure SSO 登录
 * @return {boolean} 是否
 */
export const isAzureAuth = 'azure' === AUTH_TYPE;

/**
 * 使用Abbvie SSO 登录
 * @return {boolean} 是否
 */
export const isAbbvieAuth = 'abbvie' === AUTH_TYPE;

export const IGNORE_ROUTES = ['/login', '/logout', '/forget', '/password-reset', '/article', '/abbvie'];

/**
 * 给定页面是否可公开访问。
 *
 * @param pathname
 * @return {boolean}
 */
export function isPublicRoute(pathname) {
    for (let ignoreroute of IGNORE_ROUTES) {
        if (pathname.startsWith(ignoreroute)) {
            return true;
        }
    }
    return false;
}
